<template>
  <div style="width: 100%; margin-left: 1rem; margin-right: 1rem">
    <a-card>
      <a-tabs :default-active-key="defaultTabActive">
        <a-tab-pane :key="1" :tab="$t('store.allProduct')" />
        <!-- <a-tab-pane :key="2" tab="Best Seller Product" />
        <a-tab-pane :key="3" tab="Discounted Product" /> -->
        <div v-if="$store.getters['user/isDropship']" slot="tabBarExtraContent">
          <a-checkbox
            @change="onCheckAllChange"
            :indeterminate="indeterminate"
            :checked="checkedAll"
          >
            {{ $t('store.selectAll') }}
          </a-checkbox>
          <a-button
            :disabled="disableButtonBulkRemove"
            @click="() => removeFromStrore()"
          >
            {{ $t('store.removeFromStore') }}
          </a-button>
        </div>
      </a-tabs>
      <a-row>
        <a-col :xs="24" :md="12" :lg="9" class="order-2 mt-3">
          <a-input-search
            :placeholder="$t('store.searchProduct')"
            @change="onQueryChanged"
          />
        </a-col>
      </a-row>
      <a-row class="mt-3" type="flex" justify="space-between">
        <a-col :xs="24" :md="12" :lg="6">
          <a-form :form="filterForm">
            <a-form-item label="Sort By">
              <a-select
                v-decorator="['filter']"
                style="width: 100%"
                placeholder="Sort By"
                @change="handleFilterChange"
              >
                <a-select-option
                  v-for="(item, index) in filter"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-form>
        </a-col>
        <a-col :xs="24" :md="12" :lg="6">
          <a-form :form="sortForm">
            <a-form-item label="Order By">
              <a-select
                v-decorator="['sort']"
                style="width: 100%"
                placeholder="Order By"
                @change="handleSortChange"
              >
                <a-select-option
                  v-for="(item, index) in sort"
                  :key="index"
                  :value="item.value"
                >
                  <a-icon slot="suffixIcon" :type="item.icon" />
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
    </a-card>
    <a-tabs />
    <div
      v-if="!products.length && !loading"
      class="d-flex justify-content-center"
    >
      <div class="text-bold" style="font-size: 30px">
        <strong> {{ $t('store.productNotFound') }} </strong>
      </div>
    </div>
    <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 mx-n2">
      <div class="col px-2" v-for="(product, index) in filterProduct" :key="index">
        <ItemGrid
          :product="product"
          :index="index"
          :checkedAll="checkedAll"
          :dataChecked="dataChecked"
          :isPorductInStore="true"
          @removeFromStrore="removeFromStrore"
          @addData="addData"
          @deleteData="deleteData"
          @stock-updated="fetchProducts"
          :loading="loading"
        />
      </div>
    </div>
    <div
      class="py-5 d-flex justify-content-center align-items-center"
      v-if="totalProducts !== products.length"
    >
      <a-button @click.prevent="loadMore" :loading="loading" size="large">
        {{ $t('store.loadMore') }}
      </a-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ItemGrid from '@/components/Product/ItemGrid.vue'

const filter = [
  {
    label: 'New Product',
    value: 'newproduct',
  },
  {
    label: 'Featured Product',
    value: 'featured',
  },
  {
    label: 'Special Product',
    value: 'special',
  },
  {
    label: 'Best Seller Product',
    value: 'bestseller',
  },
  {
    label: 'Product Name',
    value: 'product_name',
  },
  {
    label: 'Commission',
    value: 'commission',
  },
  {
    label: 'Discount',
    value: 'discount',
  },
  {
    label: 'Price',
    value: 'price',
  },
  {
    label: 'Stock',
    value: 'stock',
  },
  {
    label: 'Sold Item',
    value: 'sold',
  },
]
const sort = [
  {
    label: 'ASC',
    value: 'asc',
    icon: 'caret-up',
  },
  {
    label: 'DESC',
    value: 'desc',
    icon: 'caret-down',
  },
]

export default {
  data: function () {
    return {
      defaultTabActive: 1,
      timeout: 0,
      page: 1,
      limit: 25,
      dataChecked: [],
      checkedAll: false,
      indeterminate: false,
      disableButtonBulkRemove: true,
      filter,
      filterForm: this.$form.createForm(this),
      filterBy: null,
      sort,
      sortForm: this.$form.createForm(this),
      sortBy: null,
      querySearch: null,
    }
  },
  components: {
    ItemGrid,
  },
  methods: {
    fetchProducts() {
      this.$store.dispatch('product/GETPRODUCTINSTORE', {
        page: this.page,
        limit: this.limit,
        sort: this.filterBy,
        order: this.sortBy,
        q:
          this.querySearch && this.querySearch.length
            ? this.querySearch
            : undefined,
      })
    },
    onQueryChanged(e) {
      this.querySearch = e.target.value
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        // this.filterForm.resetFields('filter')
        // this.sortForm.resetFields('sort')
        this.filterForm.resetFields()
        this.sortForm.resetFields()
        this.filterBy = null
        this.sortBy = null
        this.fetchProducts()
      }, 1000)
    },
    loadMore() {
      this.page += 1
      this.fetchProducts()
    },
    removeFromStrore(value) {
      if (value) {
        this.dataChecked = []
        this.dataChecked.push(value)
      }
      this.$store
        .dispatch('product/DELETEFROMSTORE', this.dataChecked)
        .then((_) => {
          return this.$store.dispatch('product/GETPRODUCTINSTORE', {
            page: 1,
            limit: this.limit * this.page,
            sort: this.filterBy ? this.filterBy : null,
            order: this.sortBy ? this.sortBy : null,
            q: this.querySearch ? this.querySearch : null,
          })
        })
        .then((_) => {
          this.dataChecked = []
          this.checkedAll = false
          this.indeterminate = false
          this.disableButtonBulkRemove = true
          this.$notification.success({
            message: this.$t('store.successRemoveProduct'),
          })
        })
        .catch((err) => {
          this.$notification.error({
            message: this.$t('store.failedRemoveProduct'),
            description: err.response?.data?.message || err.message,
          })
        })
    },
    handleFilterChange(value) {
      this.filterBy = value
      this.page = 1
      this.fetchProducts()
    },
    handleSortChange(value) {
      this.sortBy = value
      this.page = 1
      this.fetchProducts()
    },
    onCheckAllChange(e) {
      this.checkedAll = e.target.checked
      if (e.target.checked) {
        this.indeterminate = false
        this.dataChecked = []
        this.disableButtonBulkRemove = false
        this.products.map((item) => this.dataChecked.push(item.product_id))
      } else {
        this.disableButtonBulkRemove = true
        this.dataChecked = []
      }
    },
    addData(param) {
      this.dataChecked.push(param)
      if (this.products.length === this.dataChecked.length) {
        this.indeterminate = false
        this.checkedAll = true
        this.disableButtonBulkRemove = false
      } else if (
        !!this.dataChecked.length &&
        this.dataChecked.length < this.products.length
      ) {
        this.checkedAll = false
        this.indeterminate = true
        this.disableButtonBulkRemove = false
      }
    },
    deleteData(param) {
      this.dataChecked = this.dataChecked.filter((item) => item !== param)
      if (this.products.length === this.dataChecked.length) {
        this.indeterminate = false
        this.checkedAll = true
        this.disableButtonBulkRemove = false
      } else if (
        !!this.dataChecked.length &&
        this.dataChecked.length < this.products.length
      ) {
        this.checkedAll = false
        this.indeterminate = true
        this.disableButtonBulkRemove = false
      } else if (!this.dataChecked.length) {
        this.checkedAll = false
        this.indeterminate = false
        this.disableButtonBulkRemove = true
      }
    },
    checkValidateProduct (from, until) {
      /** Check expired */
      if (this.$moment(Number(until) * 1000).isBefore(this.$moment())) {
        return 'expired'
      }

      /** Check Coming Soon */
      if (this.$moment(Number(from) * 1000).isAfter(this.$moment())) {
        return 'coming_soon'
      }

      /** Check Running */
      if (this.$moment().isBetween((Number(from) * 1000), (Number(until) * 1000))) {
        return 'available'
      }

      return 'not_set'
    },
  },
  computed: {
    ...mapState('product', {
      loading: (state) => state.loading,
      products: (state) => state.productsInStore,
      totalProducts: (state) => state.totalMyProducts,
    }),

    filterProduct () {
      if (!this.products.length) {
        return []
      }

      const checkAvailable = this.products.map((item, index) => {
        if (item.attributes.length) {
          // find start donation and finish donation
          const donationStartDate = item.attributes.find(value => value.slug === 'donation-startdate')
          const donationEndDate = item.attributes.find(value => value.slug === 'donation-enddate')

          let donationStatus = null

          if (donationStartDate || donationEndDate) {
            donationStatus = this.checkValidateProduct(donationStartDate ? donationStartDate.text : undefined, donationEndDate ? donationEndDate.text : undefined)
          }

          if (donationStatus === 'available') {
            return {
              ...item,
              donationStatus,
            }
          } else if (!donationStatus) {
            return {
              ...item,
              donationStatus: 'not_set',
            }
          }
        } else {
          return {
            ...item,
            donationStatus: 'not_have_attributes',
          }
        }
      })

      const filterProduct = checkAvailable.filter(item => !!item)

      return filterProduct
    },
  },
  created() {
    this.fetchProducts()
  },
}
</script>
